(function () {
  'use strict';
  var body = document.body;
  var overlay = document.querySelector('[data-sf-overlay]');
  var mobileMenu = document.getElementById('RyobiMobileMenu');
  var mobileToggle = document.getElementById('RyobiMobileMenuToggle');
  var cartDrawer = document.getElementById('RyobiCartDrawer');
  var cartToggle = document.querySelector('.sf-cart-toggle');
  var lastFocus = null;

  function setOverlay(open) {
    if (!overlay) return;
    overlay.hidden = !open;
    body.classList.toggle('lock-scroll', open);
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    mobileToggle?.setAttribute('aria-expanded', 'false');
    setOverlay(false);
    lastFocus?.focus();
  }
  function openMobileMenu() {
    if (!mobileMenu) return;
    lastFocus = document.activeElement;
    mobileMenu.hidden = false;
    mobileToggle?.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    mobileMenu.querySelector('button,a')?.focus();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    cartToggle?.setAttribute('aria-expanded', 'false');
    setOverlay(false);
    lastFocus?.focus();
  }
  function openCart() {
    if (!cartDrawer) return;
    lastFocus = document.activeElement;
    cartDrawer.hidden = false;
    cartToggle?.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    cartDrawer.querySelector('button,a')?.focus();
  }
  mobileToggle?.addEventListener('click', function () { mobileMenu.hidden ? openMobileMenu() : closeMobileMenu(); });
  document.querySelector('[data-mobile-close]')?.addEventListener('click', closeMobileMenu);
  document.querySelectorAll('.sf-mobile-submenu-trigger').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      var indicator = trigger.querySelector('[aria-hidden=true]');
      if (indicator) indicator.textContent = open ? '+' : '−';
      if (panel) panel.hidden = open;
    });
  });
  var footerColumns = Array.from(document.querySelectorAll('.sf-footer__column'));
  var mobileFooter = window.matchMedia('(max-width: 767px)');
  function syncFooterColumns(event) {
    footerColumns.forEach(function (column) {
      if (event.matches) column.removeAttribute('open');
      else column.setAttribute('open', '');
    });
  }
  syncFooterColumns(mobileFooter);
  mobileFooter.addEventListener?.('change', syncFooterColumns);
  cartToggle?.addEventListener('click', function () { cartDrawer.hidden ? openCart() : closeCart(); });
  document.querySelectorAll('[data-cart-close]').forEach(function (button) { button.addEventListener('click', closeCart); });
  overlay?.addEventListener('click', function () { closeMobileMenu(); closeCart(); });

  var navTriggers = Array.from(document.querySelectorAll('.sf-nav-trigger'));
  function closeMega(except) {
    navTriggers.forEach(function (trigger) {
      if (trigger === except) return;
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }
  navTriggers.forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      closeMega(trigger);
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
    });
    trigger.closest('.sf-nav-item')?.addEventListener('mouseenter', function () {
      closeMega(trigger);
      trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    });
    trigger.closest('.sf-nav-item')?.addEventListener('mouseleave', function () {
      if (trigger.closest('.sf-nav-item')?.contains(document.activeElement)) return;
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
        panel?.querySelector('a')?.focus();
      }
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMega(); closeMobileMenu(); closeCart();
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.sf-desktop-nav')) closeMega();
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    gallery.querySelectorAll('[data-media-target]').forEach(function (button) {
      button.addEventListener('click', function () {
        window.__storeforgeVariantMediaAdapter?.setActiveMedia(gallery.closest('[data-product-handle]'), button.dataset.mediaTarget);
      });
    });
  });
  document.querySelectorAll('.sf-product').forEach(function (root) {
    var select = root.querySelector('[data-variant-select]');
    var data = root.querySelector('[data-product-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var radios = Array.from(root.querySelectorAll('.sf-option input[type=radio]'));
    function syncVariant(variant) {
      if (!variant || !select) return;
      select.value = String(variant.id);
      var option = select.selectedOptions[0];
      root.querySelectorAll('[data-variant-sku]').forEach(function (node) { node.textContent = variant.sku || ''; });
      var price = root.querySelector('[data-variant-price]');
      if (price) price.innerHTML = (option.dataset.compare && option.dataset.compare !== option.dataset.price ? '<s>' + option.dataset.compare + '</s>' : '') + '<strong>' + option.dataset.price + '</strong>';
      var add = root.querySelector('[data-add-to-cart]');
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Add to Cart' : 'Unavailable'; }
      if (variant.featured_image) window.__storeforgeVariantMediaAdapter?.setActiveMedia(root, variant.featured_image.id);
      history.replaceState({}, '', location.pathname + '?variant=' + variant.id);
    }
    select?.addEventListener('change', function () { syncVariant(variants.find(function (variant) { return String(variant.id) === select.value; })); });
    radios.forEach(function (radio) { radio.addEventListener('change', function () {
      var selected = radios.filter(function (input) { return input.checked; }).map(function (input) { return input.value; });
      var variant = variants.find(function (candidate) { return candidate.options.every(function (value, index) { return value === selected[index]; }); });
      syncVariant(variant);
    }); });
  });

  document.querySelectorAll('[data-sf-quantity-change]').forEach(function (button) {
    button.addEventListener('click', function () {
      var stepper = button.closest('.sf-quantity-stepper');
      var input = stepper?.querySelector('input[name="quantity"],input[name="updates[]"]');
      if (!input) return;
      var minimum = Number(input.min || 1);
      var maximum = input.max ? Number(input.max) : Number.MAX_SAFE_INTEGER;
      var delta = Number(button.getAttribute('data-sf-quantity-change') || 0);
      var current = Number(input.value || minimum);
      input.value = String(Math.min(maximum, Math.max(minimum, current + delta)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }
  function cartLineMarkup(item, index, cart) {
    var title = escapeHtml(item.product_title);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
    var image = item.image ? '<img src="' + escapeHtml(item.image) + '" width="80" height="80" alt="">' : '';
    var price = (item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });
    return '<article class="sf-mini-cart-item">' + image + '<div class="sf-mini-cart-item__details"><a href="' + escapeHtml(item.url) + '">' + title + '</a>' + variant + '<strong>' + price + '</strong><div class="sf-mini-cart-item__controls" aria-label="Quantity for ' + title + '"><button type="button" data-cart-line-change="' + (index + 1) + '" data-cart-line-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span aria-live="polite">' + item.quantity + '</span><button type="button" data-cart-line-change="' + (index + 1) + '" data-cart-line-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div><button class="sf-mini-cart-item__remove" type="button" data-cart-line-change="' + (index + 1) + '" data-cart-line-quantity="0">Remove</button></div></article>';
  }
  async function refreshCartDrawer() {
    var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart');
    var cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
    var content = document.querySelector('[data-cart-drawer-content]');
    if (content) content.innerHTML = cart.items.length ? cart.items.map(function (item, index) { return cartLineMarkup(item, index, cart); }).join('') : '<p>Your cart is currently empty.</p>';
    openCart();
  }
  cartDrawer?.addEventListener('click', function (event) {
    var viewCartLink = event.target.closest('[data-cart-view]');
    if (!viewCartLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(viewCartLink.href || '/cart');
  }, true);
  cartDrawer?.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-cart-line-change]');
    if (!button) return;
    var line = Number(button.getAttribute('data-cart-line-change'));
    var quantity = Number(button.getAttribute('data-cart-line-quantity'));
    if (!Number.isInteger(line) || line < 1 || !Number.isInteger(quantity) || quantity < 0) return;
    cartDrawer.querySelectorAll('[data-cart-line-change]').forEach(function (control) { control.disabled = true; });
    try {
      var response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) });
      if (!response.ok) throw new Error('Unable to update this item');
      await refreshCartDrawer();
    } catch (error) {
      alert(error.message);
      cartDrawer.querySelectorAll('[data-cart-line-change]').forEach(function (control) { control.disabled = false; });
    }
  });
  document.querySelectorAll('.sf-card-form,.sf-product-form').forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var submit = form.querySelector('[type=submit]');
      if (submit) submit.disabled = true;
      try {
        var response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this item');
        await refreshCartDrawer();
      } catch (error) { alert(error.message); }
      finally { if (submit) submit.disabled = false; }
    });
  });
  document.querySelectorAll('[data-product-track]').forEach(function (track) {
    var scroller = track.querySelector('[data-track-scroller]');
    var previous = track.querySelector('[data-track-prev]');
    var next = track.querySelector('[data-track-next]');
    if (!scroller) return;
    function move(direction) {
      var card = scroller.querySelector('.sf-product-card');
      var amount = card ? card.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.85;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    previous?.addEventListener('click', function () { move(-1); });
    next?.addEventListener('click', function () { move(1); });
  });
  document.querySelector('[data-collection-sort]')?.addEventListener('change', function (event) {
    var url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); location.assign(url.toString());
  });
})();
